<!-- Help Button -->
<button mat-icon-button
        class="text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800"
        (click)="openPanel()"
        #shortcutsOrigin>

  <mat-icon>help_outline</mat-icon>

</button>

<!-- Help Panel -->
<ng-template #shortcutsPanel>

  <div class="fixed inset-0 sm:static sm:inset-auto flex flex-col sm:w-[380px]
               bg-white dark:bg-gray-900
               rounded-2xl overflow-hidden shadow-2xl
               border border-gray-200 dark:border-gray-700">

    <!-- Header -->
    <div class="bg-[#0C2459] dark:bg-[#071633] text-white px-5 py-4">

      <div class="flex justify-between items-center">

        <div>

          <h2 class="text-xl font-semibold">
            {{'HowCanWeHelp' | translate}}
          </h2>

          <p class="text-xs text-blue-100 dark:text-blue-200 mt-1">
            Find articles, videos or contact support.
          </p>

        </div>

        <button mat-icon-button
                class="sm:hidden text-white"
                (click)="closePanel()">

          <mat-icon>close</mat-icon>

        </button>

      </div>

    </div>

    <!-- Body -->
    <div class="p-4">

      <div class="grid grid-cols-2 gap-3">

        <!-- Support Center -->
        <div (click)="GoToHelpCenter()"
             class="group cursor-pointer rounded-xl
                           border border-gray-200 dark:border-gray-700
                           bg-white dark:bg-gray-800
                           hover:border-blue-300 dark:hover:border-blue-500
                           hover:shadow-md transition-all duration-200">

          <div class="flex flex-col items-center py-4 px-2">

            <div class="w-12 h-12 rounded-full bg-blue-50 dark:bg-blue-900/30 flex items-center justify-center mb-3">

              <mat-icon class="text-blue-700 dark:text-blue-300">
                help_outline
              </mat-icon>

            </div>

            <div class="font-semibold text-sm text-center text-gray-900 dark:text-gray-100">
              {{'SupportCenter' | translate}}
            </div>

            <div class="text-xs text-gray-500 dark:text-gray-400 text-center mt-1">
              {{'ListofArticle' | translate}}
            </div>

          </div>

        </div>

        <!-- Videos -->
        <div (click)="GoToVideos()"
             class="group cursor-pointer rounded-xl
                           border border-gray-200 dark:border-gray-700
                           bg-white dark:bg-gray-800
                           hover:border-red-300 dark:hover:border-red-500
                           hover:shadow-md transition-all duration-200">

          <div class="flex flex-col items-center py-4 px-2">

            <div class="w-12 h-12 rounded-full bg-red-50 dark:bg-red-900/30 flex items-center justify-center mb-3">

              <mat-icon class="text-red-600 dark:text-red-300">
                play_circle
              </mat-icon>

            </div>

            <div class="font-semibold text-sm text-center text-gray-900 dark:text-gray-100">
              {{'YoutubeVideo' | translate}}
            </div>

            <div class="text-xs text-gray-500 dark:text-gray-400 text-center mt-1">
              {{'InstructionalVideos' | translate}}
            </div>

          </div>

        </div>

        <!-- Chat -->
        <div onclick="zE('webWidget', 'show')"
             (click)="closePanel()"
             class="group cursor-pointer rounded-xl
                           border border-gray-200 dark:border-gray-700
                           bg-white dark:bg-gray-800
                           hover:border-green-300 dark:hover:border-green-500
                           hover:shadow-md transition-all duration-200">

          <div class="flex flex-col items-center py-4 px-2">

            <div class="w-12 h-12 rounded-full bg-green-50 dark:bg-green-900/30 flex items-center justify-center mb-3">

              <mat-icon class="text-green-600 dark:text-green-300">
                chat
              </mat-icon>

            </div>

            <div class="font-semibold text-sm text-center text-gray-900 dark:text-gray-100">
              {{'ChatSupport' | translate}}
            </div>

            <div class="text-xs text-gray-500 dark:text-gray-400 text-center mt-1">
              {{'LiveChatSupport' | translate}}
            </div>

          </div>

        </div>

        <!-- Submit Ticket -->
        <div (click)="GoToSupport()"
             class="group cursor-pointer rounded-xl
                           border border-gray-200 dark:border-gray-700
                           bg-white dark:bg-gray-800
                           hover:border-orange-300 dark:hover:border-orange-500
                           hover:shadow-md transition-all duration-200">

          <div class="flex flex-col items-center py-4 px-2">

            <div class="w-12 h-12 rounded-full bg-orange-50 dark:bg-orange-900/30 flex items-center justify-center mb-3">

              <mat-icon class="text-orange-500 dark:text-orange-300">
                support_agent
              </mat-icon>

            </div>

            <div class="font-semibold text-sm text-center text-gray-900 dark:text-gray-100">
              {{'SubmitTicket' | translate}}
            </div>

            <div class="text-xs text-gray-500 dark:text-gray-400 text-center mt-1">
              {{'Supporttickets' | translate}}
            </div>

          </div>

        </div>

      </div>

    </div>

    <!-- Support PIN -->
    <div class="border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 px-5 py-4">

      <div class="text-center">

        <div class="text-xs uppercase tracking-wide text-gray-500 dark:text-gray-400">
          {{'SupportPin' | translate}}
        </div>

        <div class="text-2xl font-bold tracking-widest mt-1 text-[#0C2459] dark:text-blue-300">
          {{supportPin || "--"}}
        </div>

        <div class="flex justify-center gap-2 mt-4">

          <button mat-stroked-button
                  color="primary"
                  class="!h-8 !min-h-8 !px-3 text-xs" (click)="copySupportPin()">

            <mat-icon class="!text-[18px] !w-[18px] !h-[18px] mr-1">
              content_copy
            </mat-icon>

            {{'Copy' | translate}}

          </button>

          <button mat-flat-button
                  color="primary"
                  class="!h-8 !min-h-8 !px-3 text-xs"
                  (click)="generateSupportPin()">

            <mat-icon class="!text-[18px] !w-[18px] !h-[18px] mr-1">
              refresh
            </mat-icon>

            {{'Refresh' | translate}}

          </button>

        </div>

      </div>

    </div>

  </div>

</ng-template>
